import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../api/../mutation-types";

const actions = {
  //MeasureUnits
  getMeasureUnits({ commit }, payload) {
    payload = payload || {};
    payload.limit = payload.limit || 1000;
    return api.fetch(endpoints.MEASURE_UNITS, payload, commit, (response) => {
      commit(types.SET_MEASURE_UNITS, response.data.data);
      commit("common/" + types.SET_PAGINATION, response.data.pagination, {
        root: true,
      });
    });
  },
  searchMeasureUnits({ commit }, payload) {
    payload = payload || {};
    payload.limit = payload.limit || 1000;
    return api.fetch(endpoints.MEASURE_UNITS, payload, commit, (response) => {
      commit(types.SET_MEASURE_UNITS, response.data.data);
    });
  },
  getMeasureUnitsFull({ commit }, payload) {
    return api.fetchFull(endpoints.MEASURE_UNITS, payload, commit, (response) => {
      return response;
    });
  },
  syncErpLegacyMeasureUnits({ commit }, payload) {
    return api.post(endpoints.ERP_LEGACY_SYNC_MEASURE_UNITS, payload ?? {}, commit, (response) => {
      return response;
    });
  },
  getErpLegacyMeasureUnits({ commit }) {
    return api.fetchFull(endpoints.ERP_LEGACY_MEASURE_UNITS, {}, commit, (response) => response);
  },
  storeErpMeasureUnitMapping({ commit }, payload) {
    return api.post(endpoints.ERP_LEGACY_MEASURE_UNIT_MAPPINGS, payload, commit, (response) => response);
  },
  updateErpMeasureUnitMapping({ commit }, { id, ...payload }) {
    return api.put(endpoints.ERP_LEGACY_MEASURE_UNIT_MAPPINGS + '/' + id, payload, commit, (response) => response);
  },
  destroyErpMeasureUnitMapping({ commit }, id) {
    return api.remove(endpoints.ERP_LEGACY_MEASURE_UNIT_MAPPINGS + '/' + id, {}, commit, (response) => response);
  },
  getErpMeasureUnitMappings({ commit }) {
    return api.fetchFull(endpoints.ERP_LEGACY_MEASURE_UNIT_MAPPINGS, {}, commit, (response) => response);
  },
  getMeasureUnit({ commit }, payload) {
    return api.fetch(
      endpoints.MEASURE_UNITS + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        commit(types.SET_MEASURE_UNIT, response.data);
      }
    );
  },
};

export default actions;
